// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"sidebar__YpiSL"};